import PropTypes from "prop-types";

export const bannerProps = {
  hideBanner: PropTypes.func.isRequired,
};
